// extracted by mini-css-extract-plugin
export default {"contact__element":"ContactinfoElement_contact__element__BGn+E","contact__text":"ContactinfoElement_contact__text__yyd00"};